//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useEffect, useState } from 'react';

// === STYLES ===
import {
  TableRow,
  TableCell,
  IconButton,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tooltip,
} from '@mui/material';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

//#endregion

export function ModuleRow({ module, removeModule }) {
  //#region [VALUES]

  const [deleteModuleConfirmDialog, setDeleteModuleConfirmDialog] =
    useState(false);

  //#endregion

  //#region [EFFECT]
  useEffect(() => {}, []);
  //#endregion

  //#region [MODIFY]

  const handleDeleteModuleDialogClick = () => {
    setDeleteModuleConfirmDialog(true);
  };

  const handleDeleteModuleDialogConfirm = () => {
    removeModule(module.id);
    setDeleteModuleConfirmDialog(false);
  };

  const handleDeleteModuleDialogAbort = () => {
    setDeleteModuleConfirmDialog(false);
  };

  const displayDeleteModuleDialog = () => {
    return (
      <Dialog
        open={deleteModuleConfirmDialog}
        onClose={handleDeleteModuleDialogAbort}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>
          {'Confirm Module Deletion'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            Are you sure you want to DELETE the Module? Be advised, this action
            cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleDeleteModuleDialogAbort}
            color='primary'
            autoFocus
          >
            Abort
          </Button>
          <Button
            onClick={handleDeleteModuleDialogConfirm}
            color='primary'
            autoFocus
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  //#endregion

  //#region [DISPLAY]
  function display() {
    return (
      <TableRow className='' key={module.id}>
        <TableCell>
          <Tooltip title='Delete Module'>
            <IconButton
              aria-label='delete-module'
              aria-controls='delete-module'
              color='primary'
              onClick={handleDeleteModuleDialogClick}
            >
              <DeleteForeverIcon fontSize='small' />
            </IconButton>
          </Tooltip>
        </TableCell>
        <TableCell>{module.ModuleName}</TableCell>
        {displayDeleteModuleDialog()}
      </TableRow>
    );
  }
  //#endregion

  return display();
}
